import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#3CC8FF"
  }} d="M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621  c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38  C512,406.557,494.833,423.724,473.655,423.724z" /><polygon style={{
    fill: "#464655"
  }} points="256.057,114.759 132.471,397.241 379.644,397.241 " /><path style={{
    fill: "#F5F5F5"
  }} d="M256.057,158.806l96.591,220.78H159.466L256.057,158.806 M256.057,114.759L132.471,397.241h247.172  L256.057,114.759L256.057,114.759z" /><polygon style={{
    fill: "#FFE15A"
  }} points="132.471,397.241 256.057,256 379.644,397.241 " /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };